
import { IFileAttachment, FileOrLink, IAttachmentFormPayload, IAttachmentTypeListItem } from "models/attachments";
import { useEffect, useReducer } from "react";
import { useTaskAttachmentAdd, useTaskAttachmentValidation, useTaskContext } from "hooks/tasks";
import { useSnackbar } from "@sagecentral/core-ui";
import { AttachmentForm } from "components/attachments";
import { useEditAttachment } from "hooks/attachments";

type TaskAttachmentProps = {
    edit?: boolean;
    types: IAttachmentTypeListItem[] | null;
    onClose: () => void;
    onRefresh: () => void;
    attachments: IFileAttachment[];
    attachmentData?: IAttachmentFormPayload;
}

const TaskAttachment = (props: TaskAttachmentProps) => {
    const { edit, types, onClose, onRefresh, attachments, attachmentData } = props;
    const taskContext = useTaskContext();
    const { task, template, updateTaskOverview } = taskContext;
    const { displaySnackbar } = useSnackbar();
  
    const [ payload, updatePayload ] = useReducer((state: IAttachmentFormPayload, action: Partial<IAttachmentFormPayload>) => {
        return {
            ...state,
            ...action
        };
    }, { 
        typeId: 0,
        fileOrLink: FileOrLink.File
    });

    useEffect(() => {
        if (attachmentData) {
            updatePayload(attachmentData);
            attachmentData.filePath = undefined;
        }
    }, [ attachmentData ]);

    const validator = useTaskAttachmentValidation({
        attachmentId: payload.id,
        taskId: task?.id, 
        typeId: payload.typeId, 
        fileOrLink: payload.fileOrLink
    });

    const [ handleEdit, editWorking ] = useEditAttachment();
    const [ handleTaskAttachmentAdd, addWorking ] = useTaskAttachmentAdd();

    const handleSave = async () => {
        if (edit) {
            const result = await handleEdit(task?.id ?? 0, payload);
            if (result !== null) {
                onRefresh();
                onClose();
            }
        } else {
            const result = await handleTaskAttachmentAdd(task?.id ?? 0, payload);
            if (result) {                
                onRefresh();
                onClose();
            }
        }
    };

    const checkExisting = (payload: IAttachmentFormPayload) => {
        const filenames = payload.files?.map(v => v.name) ?? [];
        if (payload.fileOrLink === FileOrLink.SFTP) {
            filenames.push(payload.name!);
        }
        for (var item of attachments) {
            if (item.workItemInstanceAttachmentID === payload.id) continue;
            if (item.attachmentTypeID === payload.typeId && item.fileOrURLType == payload.fileOrLink) {
                // compare without case sensitivity.
                if (item.attachmentName.toLowerCase() === payload.name?.toLowerCase())
                    return true;
                const idx = filenames.findIndex(f => item.attachmentName === f);                
                if (idx !== -1) {
                    return true;
                }
            }

        }
        return false;
    }

    return (
        <AttachmentForm 
            edit={edit}
            saving={addWorking || editWorking}
            payload={payload} 
            updatePayload={updatePayload} 
            validator={validator} 
            types={types} 
            onSave={handleSave} 
            onClose={onClose} 
            onCheckExisting={checkExisting}
        /> 
    )
};

export default TaskAttachment;